import { DownloadCsvButton } from "../../../components/DownloadCsvButton";
import {
    Card,
    CardContent,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    ToggleButton,
    ToggleButtonGroup
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";


const transformDataToArrayOfObjects = (data) => {
    const output = [];
    const pointTypes = Object.keys(data);
    const pointTypeCsvNameMap = {
        "motion_event": "Motion",
        "occupancy_event": "Occupied",
        "occupancy_count": "Occupancy Count",
    }
    const timestamps = data[pointTypes[0]].timestamps;



    //check timestamps are all the same 
    for (let i = 0; i < pointTypes.length; i++) {
        if (data[pointTypes[i]].timestamps.length !== data[pointTypes[0]].timestamps.length) {
            console.warn("Timestamps length mismatch between point types. Cannot transform data to array of objects.");
            return [];
        }



        data[pointTypes[i]].points_data.forEach((pointData) => {
            let transformedPointData = {
                "point_name": pointData.metadata?.name,
                "point_type": pointTypeCsvNameMap[pointTypes[i]]
            }
            for (let j = 0; j < timestamps.length; j++) {
                transformedPointData[timestamps[j]] = pointData.values[j];
            }
            output.push(transformedPointData);

        });

    }

    return output;
}

export default function OccupancyFiltersCard({ selectedHours, setSelectedHours, selectedDays, setSelectedDays, downloadableData }) {
    const { t } = useTranslation();
    const [startHour, setStartHour] = React.useState(0);
    const [endHour, setEndHour] = React.useState(23);

    React.useEffect(() => {
        setStartHour(selectedHours[0] || 0);
        setEndHour(selectedHours[selectedHours.length - 1] || 23);
    });

    const hourOptions = Array.from({ length: 24 }, (_, hour) => ({
        value: hour,
        label: `${hour.toString().padStart(2, "0")}:00`
    }));


    const dayOfWeekOptions = [
        { value: 0, label: t("Sun") },
        { value: 1, label: t("Mon") },
        { value: 2, label: t("Tue") },
        { value: 3, label: t("Wed") },
        { value: 4, label: t("Thu") },
        { value: 5, label: t("Fri") },
        { value: 6, label: t("Sat") },
    ]

    const buildHourRange = (start, end) => {
        const rangeStart = Math.min(start, end);
        const rangeEnd = Math.max(start, end);
        return Array.from({ length: rangeEnd - rangeStart + 1 }, (_, index) => rangeStart + index);
    };

    const normalizedDays = (selectedDays || []).map((value) => Number(value));
    const handleDayChange = (event, newSelectedDays) => {
        setSelectedDays(newSelectedDays || []);
    };

    const csvData = transformDataToArrayOfObjects(downloadableData);


    return (
        <Card sx={{ mx: { xs: 2, md: 3 }, my: 2 }}>
            <CardContent>
                <Stack direction="row" spacing={2} alignItems="flex-start" flexWrap="wrap">
                    <Stack direction="row" spacing={2} alignItems="center">
                        <FormControl size="small" sx={{ minWidth: 140 }}>
                            <InputLabel id="occupancy-start-hour-label">{t("Start")}</InputLabel>
                            <Select
                                labelId="occupancy-start-hour-label"
                                label={t("Start")}
                                value={startHour}
                                onChange={(event) => {
                                    const newStart = event.target.value;
                                    setStartHour(newStart);
                                    setSelectedHours(buildHourRange(newStart, endHour));
                                }}
                            >
                                {hourOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl size="small" sx={{ minWidth: 140 }}>
                            <InputLabel id="occupancy-end-hour-label">{t("End")}</InputLabel>
                            <Select
                                labelId="occupancy-end-hour-label"
                                label={t("End")}
                                value={endHour}
                                onChange={(event) => {
                                    const newEnd = event.target.value;
                                    setEndHour(newEnd);
                                    setSelectedHours(buildHourRange(startHour, newEnd));
                                }}
                            >
                                {hourOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Stack>

                    <Stack>
                        <ToggleButtonGroup
                            size="small"
                            value={normalizedDays}
                            onChange={handleDayChange}
                        >
                            {dayOfWeekOptions.map((option) => (
                                <ToggleButton key={option.value} value={option.value}>
                                    {option.label}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </Stack>

                    <Stack>
                        <DownloadCsvButton arrayOfObjectsData={csvData} filename="occupancy_data.csv" buttonText={t("Download CSV")} />
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    )
}